(() => {
  if (window.__seshSmartCartBound) return;
  window.__seshSmartCartBound = true;

  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-sesh-variant-select]');
    if (!select) return;

    const card = select.closest('[data-sesh-smart-card]');
    if (!card) return;

    const option = select.options[select.selectedIndex];
    const button = card.querySelector('[data-sesh-smart-add]');
    const price = card.querySelector('[data-sesh-smart-price]');

    if (button) button.dataset.variantId = option.value;
    if (price && option.dataset.price) price.textContent = option.dataset.price;
  });

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-sesh-smart-add]');
    if (!button) return;

    event.preventDefault();
    if (button.disabled) return;

    const wrapper = button.closest('[data-sesh-smart-cart]');
    const status = wrapper ? wrapper.querySelector('[data-sesh-smart-status]') : null;
    const variantId = Number(button.dataset.variantId);
    const originalLabel = button.dataset.defaultLabel || button.textContent;

    button.disabled = true;
    button.textContent = button.dataset.addingLabel || originalLabel;
    if (status) status.textContent = '';

    try {
      const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      });

      if (!response.ok) throw new Error('Cart add failed');

      button.textContent = button.dataset.addedLabel || originalLabel;

      if (typeof window.refreshCart === 'function') {
        window.refreshCart();
      } else {
        window.location.reload();
      }
    } catch (error) {
      button.disabled = false;
      button.textContent = originalLabel;
      if (status) status.textContent = button.dataset.errorLabel || '';
    }
  });
})();